//кнопка вверх
$(document).ready(function () {
	$(window).scroll(function () {
		if ($(document).scrollTop() > 10) {
			$('#scroll').css('display', 'block');
		} else {
			$('#scroll').css('display', 'none');
		}
	});
	$('#toTop').click(function () {
		$('html, body').animate({scrollTop: $('html').offset().top}, 'slow');
		return false;
	});
	// setTimeout(() => {
	// 	let posTop = document.querySelector('header').offsetHeight + 50;
	// 	document.querySelector('body').style.paddingTop = `${posTop}px`;
	// }, 200);

	//это сделано исключительно из-за того, что добавилась  инфострока в шапке.
	if ($('header').hasClass('info-text')) {
		$('body').addClass('info-text');
	}

	Fancybox.bind("[data-fancybox]", {
		// Your custom options
	});
});

if (document.getElementsByClassName('image-text-link').length > 0) {
	$('.image-text-link').magnificPopup({type: 'image'});
}


$('.screen.seo-text .read-more').click(function () {
	$('.screen.seo-text .background').toggleClass('active');

	if ($('.screen.seo-text .background').hasClass('active')) {
		$('.screen.seo-text .read-more .read-more-text').text(Lang.get('js.hide'));
	} else {
		$('.screen.seo-text .read-more .read-more-text').text(Lang.get('js.show_more'));
	}
});

$('.product-item .show-more').click(function () {
	$(this).toggleClass('active');
	$(this).parent().children('.description-table').toggleClass('active');

	if ($(this).hasClass('active')) {
		$(this).children('.show-more-text').text(Lang.get('js.hide'));
	} else {
		$(this).children('.show-more-text').text(Lang.get('js.show_more'));
	}
});

//Плавная анимация якоря
$('.anchor-animate').click(function (event) {
	event.preventDefault();
	let id = $(this).attr('href'),
		top = $(id).offset().top;
	if ($(window).width() <= 767) {
		top -= 50;
	} else if ($(window).width() > 767 && $(window).width() <= 991) {
		top -= 100;
	} else if ($(window).width() > 991) {
		top -= 150;
	}
	$('body,html').animate({scrollTop: top}, 300);
});

$(document).ready(function () {
//menu
	const menu = document.querySelector('.hidden-menu');
	const btnBurgerHidden = document.getElementById('btn-burger-hidden');
	const btnBurgerOpen = document.getElementById('btn-burger-open');
// console.log(btnBurgerHidden);


	if (btnBurgerHidden) {
		btnBurgerHidden.addEventListener('click', function () {
			document.querySelector('.modal-menu').style.top = `${document.querySelector('header').offsetHeight}px`;
			setTimeout(() => {
				menu.classList.toggle('open-menu');
				btnBurgerHidden.classList.toggle('active');
				// btnBurgerOpen.classList.toggle('active');
				btnBurgerHidden.classList.toggle('not-active');
				// btnBurgerOpen.classList.toggle('not-active');
				$('body').toggleClass('active');
			}, 200);

		}, false);
	}

	if (btnBurgerOpen) {
		btnBurgerOpen.addEventListener('click', function () {
			menu.classList.toggle('open-menu');
			btnBurgerHidden.classList.toggle('active');
			btnBurgerOpen.classList.toggle('active');
			btnBurgerHidden.classList.toggle('not-active');
			btnBurgerOpen.classList.toggle('not-active');
			$('body').toggleClass('active');

		}, false);
	}
});


$('.reviews-block__slick').slick({
	dots: false,
	infinite: true,
	speed: 300,
	slidesToShow: 3,
	slidesToScroll: 1,
	adaptiveHeight: true,
	lazyLoad: 'ondemand',

	// centerMode: true,
	// centerPadding: '60px',
	responsive: [
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 1,
			}
		},
	],
});


$('.product-img-slick-slider').slick({
	dots: false,
	infinite: true,
	speed: 300,
	slidesToShow: 1,
	slidesToScroll: 1,
	adaptiveHeight: true,
	lazyLoad: 'ondemand',
	responsive: [
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 1,
			}
		},
	],
});


//article read progress
$(window).scroll(function () {

	let w = window,
		d = document,
		e = d.documentElement,
		g = d.getElementsByTagName('body')[0],
		y = w.innerHeight || e.clientHeight || g.clientHeight;
	let hFooter = $('footer').innerHeight();
	let hOtherArticle = $('.other-article').innerHeight();
	let minusHeight = hFooter + hOtherArticle;


	var wScroll = $(this).scrollTop();
	let ratio = $(document).scrollTop() / (($(document).height() - y - minusHeight) / 100);
	$(window).bind('mousewheel DOMMouseScroll MozMousePixelScroll', function (event) {
		let delta = parseInt(event.originalEvent.wheelDelta || -event.originalEvent.detail);
		// if ($(window).width() > 992) {
		//   if (delta >= 0) {
		//     $('header').css('opacity', '1');
		//     $('header').css('z-index', '9');
		//   } else {
		//     $('header').css('opacity', '0');
		//     $('header').css('z-index', '-1');
		//   }
		// }
	});
	$("#progress").width(ratio + "%");

});

//header mobile
$(document).ready(function () {
	$(window).scroll(function () {
		if ($(document).scrollTop() > 50) {
			$('header').addClass('fixed');
		} else {
			$('header').removeClass('fixed');
		}
	});
});


//видео из ютуб
function findVideos() {
	let videos = document.querySelectorAll('.video');

	for (let i = 0; i < videos.length; i++) {

		setupVideo(videos[i]);
	}
}

function setupVideo(video) {
	let link = video.querySelector('.video__link');
	let media = video.querySelector('.video__media');
	let button = video.querySelector('.video__button');
	let id = parseMediaURL(media);

	video.addEventListener('click', () => {
		let iframe = createIframe(id);

		link.remove();
		button.remove();
		video.appendChild(iframe);
	});

	link.removeAttribute('href');
	video.classList.add('video--enabled');
}

function parseMediaURL(media) {
	let regexp = /https:\/\/i\.ytimg\.com\/vi\/([a-zA-Z0-9_-]+)\/sddefault\.jpg/i;
	let url = media.src;
	let match = url.match(regexp);

	return match[1];
}

function createIframe(id) {
	let iframe = document.createElement('iframe');

	iframe.setAttribute('allowfullscreen', '');
	iframe.setAttribute('allow', 'autoplay');
	iframe.setAttribute('src', generateURL(id));
	iframe.classList.add('video__media');

	return iframe;
}

function generateURL(id) {
	let query = '?rel=0&showinfo=0&autoplay=1';

	return 'https://www.youtube.com/embed/' + id + query;
}

findVideos();


// WEBPACK FOOTER //
// ./resources/js/snippets/common.js